export default __webpack_public_path__ + "static/media/boardingActive.9813f3cb.svg";